import { useState } from 'react';
import { toast } from 'sonner';
import type { DatabaseConfig, ConnectionStatus } from '@/types/database';

export const useDatabaseConnection = () => {
  const [isTestingConnection, setIsTestingConnection] = useState(false);
  const [connectionStatus, setConnectionStatus] = useState<ConnectionStatus>('idle');

  const testConnection = async (config: DatabaseConfig): Promise<boolean> => {
    setIsTestingConnection(true);
    setConnectionStatus('testing');
    
    try {
      if (config.type === 'supabase') {
        const response = await fetch(`${config.config.url}/rest/v1/`, {
          headers: {
            'apikey': config.config.anonKey!,
            'Authorization': `Bearer ${config.config.anonKey!}`
          }
        });
        
        if (response.ok) {
          setConnectionStatus('success');
          toast.success("تم الاتصال بقاعدة بيانات Supabase بنجاح!");
          return true;
        }
      } else if (config.type === 'mysql' || config.type === 'postgresql') {
        // للقواعد التقليدية، نحتاج لاستخدام API خاص أو proxy
        // هنا نضع محاكاة للاختبار
        await new Promise(resolve => setTimeout(resolve, 2000)); // محاكاة التأخير
        
        // تحقق أساسي من وجود البيانات المطلوبة
        if (config.config.host && config.config.database && config.config.username) {
          setConnectionStatus('success');
          toast.success(`تم الاتصال بقاعدة بيانات ${config.type.toUpperCase()} بنجاح!`);
          return true;
        }
      }
      
      setConnectionStatus('error');
      toast.error("فشل الاتصال بقاعدة البيانات");
      return false;
    } catch (error) {
      setConnectionStatus('error');
      toast.error("خطأ في الاتصال بقاعدة البيانات");
      return false;
    } finally {
      setIsTestingConnection(false);
      setTimeout(() => setConnectionStatus('idle'), 3000);
    }
  };

  return {
    isTestingConnection,
    connectionStatus,
    testConnection
  };
};